import DOMPurify from 'dompurify';

// Source: https://gitlab.com/gitlab-org/gitlab/-/blob/master/app/assets/javascripts/vue_shared/directives/safe_html.js

// Mitigate against future dompurify mXSS bypasses by
// avoiding additional serialize/parse round trip.
// See https://gitlab.com/gitlab-org/gitlab-ui/-/merge_requests/1782
// and https://gitlab.com/gitlab-org/gitlab-ui/-/merge_requests/2127
// for more details.

DOMPurify.addHook('afterSanitizeElements', function (currentNode) {
  if (currentNode.hasAttribute && currentNode.hasAttribute('target')) {
    if (currentNode.tagName !== 'A') {
      currentNode.removeAttribute('target');

      return;
    }

    const targetValue = currentNode.getAttribute('target');
    if (targetValue !== '_blank') {
      currentNode.removeAttribute('target');
    }
  }
});

const DEFAULT_CONFIG = {
  ADD_ATTR: ['target'],
  RETURN_DOM_FRAGMENT: true,
};

const transform = (el, binding) => {
  if (binding.oldValue !== binding.value) {
    const config = { ...DEFAULT_CONFIG, ...binding.arg };

    el.textContent = '';

    el.appendChild(DOMPurify.sanitize(binding.value, config));
  }
};

const clear = (el, binding) => {
  // Fixes https://gitlab.com/gitlab-org/gitlab-services/design.gitlab.com/-/issues/2452

  delete binding.oldValue;
  el.textContent = '';
};

export default {
  beforeMount: transform,
  updated: transform,
  beforeUnmount: clear,
};
